import {  memo, type PropsWithChildren } from "react";
import { Navigate, useLocation } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";
import useAuthentication from "features/auth/useAuthentication";

const RedirectIfAuthenticated = ({ children }: PropsWithChildren) => {
    const location = useLocation();
    const { isAuthenticated, isPending } = useAuthentication();

    if (isPending()) {
        return null;
    }

    const from = (location.state as any)?.from?.pathname || WebRoutes.Root;

    if (isAuthenticated()) {
        return <Navigate to={from} state={{ from: undefined }} replace />;
    }

    return (
        <>
            {children}
        </>
    );
};

export default memo(RedirectIfAuthenticated);
